import { pbrExt } from './fragments/uv-transform-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function enableMaterialUvTransform(material) {
  material._hasUvTx = true;
  _registerPbrExt(pbrExt);
  return material._renderFeatures === void 0;
}

export { enableMaterialUvTransform };
//# sourceMappingURL=enable-material-uv-transform.js.map
